<template>
    <v-container>
            <v-form ref="form" lazy-validation>
                <v-row>
                <v-col>
                    <v-select
                        v-model="searchItem"
                        :items=searchItems
                        @change="onSearchItemChange"
                        item-text="text"
                        item-value="value"
                        id="search"
                        label="ค้นหา"
                        outlined
                    >
                    </v-select>
                </v-col>
                <v-col >
                    <v-text-field  ref="searchValue" @keyup.enter.native="search" :error="isError"  v-model="searchValue" :label="searchValueLabel"  placeholder="กรอกข้อมูลคำค้น" outlined></v-text-field>
                </v-col>
            </v-row>
             <v-row>
                <v-col><DatePicker label="ตั้งแต่วันที่" @dateFormatted="setDateFrom" ></DatePicker></v-col>
                <v-col><DatePicker label="ถึงวันที่" @dateFormatted="setDateTo" ></DatePicker></v-col>
                <v-spacer></v-spacer>
                <v-col class="text-right">
                    <v-row>
                        <v-btn  class="ma-2" color="primary" small @click="search"><v-icon>search</v-icon> ค้นหา</v-btn>
                        <AddStockConsumableOffice :branchCode="branchCode" @close="close"></AddStockConsumableOffice>
                    </v-row>
                </v-col>
            </v-row>
            </v-form>
        <v-data-table
            :headers="headers"
            :items="items"
            class="pt-5"
            fixed-header
            height="350"
        >

            <template v-slot:top>
                <v-dialog v-model="viewDialog" persistent>
                    <ViewConsumableOffice :mainData="mainData" :itemSummary="itemSummary"  @close="close"></ViewConsumableOffice>
                </v-dialog>
                    
            </template>

            <template v-slot:item.action="{ item }">
                <v-icon
                    small
                    @click="viewData(item)"
                >
                    search
                </v-icon>
                &nbsp;
                <v-icon
                    small
                    @click="deleteData(item)"
                >
                    delete
                </v-icon>
            </template>
        </v-data-table>
    </v-container>
    
</template>

<script>
import numeral from 'numeral'
import DatePicker from '@/components/Shared/DatePicker'
import {getStockConsumable, listStockConsumableOffice, deleteDetailStockConsumable} from '@/api/stock/stock-consumable-api.js'
import ViewConsumableOffice from './ViewConsumableOffice'
import AddStockConsumableOffice from './AddStockConsumableOffice'
export default {
    name: 'Search',
    components: {
        DatePicker,
        ViewConsumableOffice,
        AddStockConsumableOffice
    },
    computed: {
        searchValueLabel() {
            return this.isError ? "กรุณากรอกข้อมูลคำค้น" : "";
        }
    },
    watch: {
        branchCode(val) {
            if (val) {
                this.search();
            }
        }
    },
    props: ["branchCode"],
    data: () => ({
        viewDialog: false,
        headers: [
            {text: "วันที่เบิก", value: "withdrawDate"},
            {text: "รหัส", value: "consumableCode"},
            {text: "ชื่อวัสดุสิ้นเปลือง", value: "consumableName"},
            {text: "Type", value: "consumableTypeText"},
            {text: "ราคา", value: "netAmount"},
            {text: "หน่วย", value: "unitOfPrice"},
            {text: "จำนวน", value: "qty"},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        items: [

        ],
        searchItems: [{text: 'รหัสวัสดุสิ้นเปลือง', value: 1},
            {text: "ชื่อวัสดุสิ้นเปลือง", value: 2},
            {text: "Supplier", value: 3}
        ],
        searchItem: 1,
        dateFrom: null,
        dateTo: null,
        searchValue: '',
        isError: false,
        itemId: -1,
        
        mainData: {
            branchCode: '',
            withdrawNo: '',
            docDate: '',
            withdrawDate: '',
            stockOfficer: '',
            withdrawDetails: []
        },
        detail: {
                consumableCode: '',
                consumableName: '',
                unitPrice: 0,
                qty: 1,
                amount: 0,
                netAmount: 0,
                remark: '',
        },
        summary: {
            sum: {
                sumType: 'รวม',
                amount: 0,
                discount: 0,
                net: 0
            },
            vat: {
                sumType: 'ภาษี 7%',
                amount: 0,
                discount: 0,
                net: 0
            },
            total: {
                sumType: 'รวมทั้งสิ้น',
                amount: 0,
                discount: 0,
                net: 0
            }
        },
        itemSummary: [],
    }),
    methods: {
        setDateFrom(val) {
            this.dateFrom = val;
        },
        setDateTo(val) {
            this.dateTo = val;
        },
        onSearchItemChange() {
            this.searchValue = '';
        },
        setDate(val) {
            this.searchValue = val;
        },
        addClick() {
            this.$emit("addClick");
        },
        search() {
            this.items =  Object.assign([], []);
            this.dateFrom = this.dateFrom.replace("/", "-").replace("/", "-");
            this.dateTo = this.dateTo.replace("/", "-").replace("/", "-");
            this.$loading(true);
            listStockConsumableOffice(this.branchCode, this.searchItem, this.searchValue, this.dateFrom, this.dateTo).then(rs => {
                this.$loading(false);
                this.items = rs;
            }).catch(() => {
                this.$loading(false);
            });
        },
        viewData(item) {
            this.itemId = item.stockConsumableId;
            this.itemSummary =  Object.assign([], []);
            this.$loading(true);
            getStockConsumable(this.itemId).then(rs => {
                this.mainData = rs;
                if (!this.mainData.details) return;
                this.mainData.details.forEach(detail => {
                    detail.amount = parseInt(detail.qty) * parseInt(detail.unitPrice);
                    this.setDetailDisplay(detail);
                    this.calculateSummary(detail);
                });

                this.itemSummary.push(this.summary.sum);
                this.itemSummary.push(this.summary.vat);
                this.itemSummary.push(this.summary.total);
                this.$loading(false);
            });
            this.viewDialog = true;
        },
        setDetailDisplay(detail) {
            detail.unitPriceDisplay = numeral(detail.unitPrice).format('0,0.00');
            detail.amountDisplay = numeral(detail.amount).format('0,0.00');
            detail.discountDisplay = numeral(detail.discount).format('0,0.00');
            detail.netAmountDisplay = numeral(detail.netAmount).format('0,0.00');
        },
        deleteData(item) {
            if (confirm('ต้องการลบ ' + item.consumableName + ' ใช่หรือไม่ ?')) {
                deleteDetailStockConsumable(item.stockConsumableDetailId).then(() => {
                    this.search();
                });
            }
        },
        close() {
            this.viewDialog = false;
            this.search();
        },
        calculateSummary(detail) {
            this.summary.sum.amount += detail.amount;
            this.summary.sum.discount += detail.discount;
            this.summary.sum.net += detail.netAmount;

            this.summary.vat.amount = (this.summary.sum.amount * 7) / 100;
            this.summary.vat.discount = (this.summary.sum.discount * 7) / 100;
            this.summary.vat.net = (this.summary.sum.net * 7) / 100;

            this.summary.total.amount = this.summary.sum.amount + this.summary.vat.amount;
            this.summary.total.discount = this.summary.sum.discount + this.summary.vat.discount;
            this.summary.total.net = this.summary.sum.net + this.summary.vat.net;

            this.setSummaryDisplay(this.summary.sum);
            this.setSummaryDisplay(this.summary.vat);
            this.setSummaryDisplay(this.summary.total);
        },
        setSummaryDisplay(summary) {
            summary.amountDisplay = numeral(summary.amount).format('0,0.00');
            summary.discountDisplay = numeral(summary.discount).format('0,0.00');
            summary.netDisplay = numeral(summary.net).format('0,0.00');
        },
    }
}
</script>